import { MetadataPutEnum } from '@models/enums/metadata-put-enum';
import { ParameterizationStepTypeEnum } from '@models/enums/parameterization-step-type-enum';
import { FormBase } from '@models/portal/users/form-base';
import { Utils } from 'src/app/core/utilities/utils';
import { ICompleteStepParameterizationDto } from '../dtos/complete-simple-step-parameterization-dto';
import { ChaveEmbateForm } from './chave-embate-form';
import { StepParameterizationSubscriptionForm } from './step-parametrization-subscription-form';
import { RodadaForm } from '@shared/services/competition/rodadas.service';
import { FederacaoEtapaForm } from './federacao-etapa-form';

export class ParameterizationPostForm extends FormBase {
  petNrQuantidadeMinimaAtuacoesQuadrasPrioritarias?: number;
    petTxNome?: string;
    petTxDescricao?: string;
    petTxBanner?: string;
    petTxExtensaoBanner?: string;
    catNrId?: number;
  cheNrIdPrincipal?: number;
  petNrMaxJogosDia?: number;
  petNrIntervaloJogos?: number;
  petNrDuracaoEmb?: number;
  petNrMaxEmbSimultaneos?: number;
  petBlTrocaOrdemConfronto?: boolean;
  petBlEmbDireto?: boolean;
  petBlPermiteMesmoEstado?: boolean;
  ettNrId?: number;
  petTxTipo?: ParameterizationStepTypeEnum;
  petNrQtdChe?: number;
  petNrQtdInc?: number;
  petNrQuantidadeCabecasDeChave?: number;
  inscricaoEtapaForms?: StepParameterizationSubscriptionForm[];
  chavesEmbateForm?: ChaveEmbateForm[];
  federacaoEtapaForm?: FederacaoEtapaForm;
  rodadaForms?: RodadaForm[];
  petBlEdicaoBloqueada?: boolean;
  mocNrId?: number;

  constructor() {
    super();
  }

  public static createFromDto(
    data: ICompleteStepParameterizationDto,
  ): ParameterizationPostForm {
    const form = new ParameterizationPostForm();
    form.petNrQuantidadeMinimaAtuacoesQuadrasPrioritarias =
      data.petNrQuantidadeMinimaAtuacoesQuadrasPrioritarias;
    form.petTxNome = data.petTxNome;
    form.petTxDescricao = data.petTxDescricao;
    form.petTxBanner = data.petTxBanner;
    form.catNrId = data.petObjCategoria?.catNrId;
    form.cheNrIdPrincipal = data.petObjChavePrincipal?.cheNrId;
    form.petNrMaxJogosDia = data.petNrMaxJogosDia;
    form.petNrIntervaloJogos = data.petNrIntervaloJogos;
    form.petNrDuracaoEmb = data.petNrDuracaoEmb;
    form.petNrMaxEmbSimultaneos = data.petNrMaxEmbSimultaneos;
    form.petBlTrocaOrdemConfronto = data.petBlTrocaOrdemConfronto;
    form.petTxTipo = data.petTxTipo;
    form.petNrQtdChe = data.petNrQtdChe;
    form.petNrQtdInc = data.petNrQtdInc;
    form.entNrId = data.petNrId;
    form.petBlEmbDireto = data.petBlEmbDireto;
    form.petBlEdicaoBloqueada = data.petBlEdicaoBloqueada;
    form.inscricaoEtapaForms = data.petListInscricoesEtapa?.map(
      (i) =>
        new StepParameterizationSubscriptionForm(
          i.ineObjInscricao?.incNrId ?? 0,
          i.incBlCabecaChave ?? false,
        ),
      (form.mocNrId = data.mocNrId),
    );

    form.federacaoEtapaForm = {
      fedNrIds: data.petListFederacoesEtapa?.map((f) => f.fedNrId!) ?? [],
    };
    form.entTxMetadado = MetadataPutEnum.INALTERADO;
    return form;
  }

  static of(form: Partial<ParameterizationPostForm>): ParameterizationPostForm {
    const newForm = new ParameterizationPostForm();
    newForm.petTxNome = form.petTxNome;
    newForm.petTxDescricao = form.petTxDescricao;
    newForm.petTxBanner = form.petTxBanner;
    newForm.petTxExtensaoBanner = form.petTxExtensaoBanner;
    newForm.catNrId = form.catNrId;
    newForm.cheNrIdPrincipal = form.cheNrIdPrincipal;
    newForm.petNrIntervaloJogos = form.petNrIntervaloJogos;
    newForm.petNrMaxJogosDia = form.petNrMaxJogosDia;
    newForm.petNrDuracaoEmb = form.petNrDuracaoEmb;
    newForm.petNrMaxEmbSimultaneos = form.petNrMaxEmbSimultaneos;
    newForm.petBlTrocaOrdemConfronto = form.petBlTrocaOrdemConfronto;
    newForm.petTxTipo = form.petTxTipo;
    newForm.petNrQtdChe = form.petNrQtdChe;
    newForm.petNrQtdInc = form.petNrQtdInc;
    newForm.petNrQuantidadeCabecasDeChave = form.petNrQuantidadeCabecasDeChave;
    newForm.petNrQuantidadeMinimaAtuacoesQuadrasPrioritarias =
      form.petNrQuantidadeMinimaAtuacoesQuadrasPrioritarias;
    newForm.entNrId = form.entNrId;
    newForm.petBlEmbDireto = form.petBlEmbDireto;
    newForm.petBlEdicaoBloqueada = form.petBlEdicaoBloqueada;
    newForm.petBlPermiteMesmoEstado = form.petBlPermiteMesmoEstado;
    newForm.inscricaoEtapaForms = form.inscricaoEtapaForms;
    newForm.mocNrId = form.mocNrId;
    newForm.chavesEmbateForm = form.chavesEmbateForm;
    newForm.rodadaForms = form.rodadaForms ?? [];
    newForm.federacaoEtapaForm = form.federacaoEtapaForm;

    newForm.entTxMetadado = form.entTxMetadado ?? MetadataPutEnum.CRIADO;
    return newForm;
  }

  verifyChanges(currentState?: ICompleteStepParameterizationDto): void {
    if (!currentState || !Utils.isDefinedAndNotNull(currentState.petNrId)) {
      this.entTxMetadado = MetadataPutEnum.CRIADO;
      return;
    }

    let modified = false;

    if (this.petTxNome !== currentState.petTxNome) modified = true;
    if (this.petTxDescricao !== currentState.petTxDescricao) modified = true;
    if (this.petTxBanner !== currentState.petTxBanner) modified = true;
    if (this.catNrId !== currentState.petObjCategoria?.catNrId) modified = true;
    if (this.cheNrIdPrincipal !== currentState.petObjChavePrincipal?.cheNrId)
      modified = true;
    if (this.petNrIntervaloJogos !== currentState.petNrIntervaloJogos)
      modified = true;
    if (this.petNrMaxJogosDia !== currentState.petNrMaxJogosDia)
      modified = true;
    if (
      this.petNrDuracaoEmb?.toString() !==
      currentState.petNrDuracaoEmb?.toString()
    )
      modified = true;
    if (this.petNrMaxEmbSimultaneos !== currentState.petNrMaxEmbSimultaneos)
      modified = true;
    if (this.petBlTrocaOrdemConfronto !== currentState.petBlTrocaOrdemConfronto)
      modified = true;
    if (this.petTxTipo !== currentState.petTxTipo) modified = true;
    if (this.petNrQtdChe !== currentState.petNrQtdChe) modified = true;
    if (this.petNrQtdInc !== currentState.petNrQtdInc) modified = true;
    if (
      this.petNrQuantidadeCabecasDeChave !==
      currentState.petNrQuantidadeCabecasDeChave
    )
      modified = true;
    if (
      this.petNrQuantidadeMinimaAtuacoesQuadrasPrioritarias !==
      currentState.petNrQuantidadeMinimaAtuacoesQuadrasPrioritarias
    )
      modified = true;
    if (this.petBlEmbDireto !== currentState.petBlEmbDireto) modified = true;
    if (this.petBlEdicaoBloqueada !== currentState.petBlEdicaoBloqueada)
      modified = true;
    if (this.mocNrId !== currentState.mocNrId) modified = true;

    const currentInsc = currentState.petListInscricoesEtapa ?? [];
    const formInsc = this.inscricaoEtapaForms ?? [];

    if (currentInsc.length !== formInsc.length) {
      modified = true;
    } else {
      for (let i = 0; i < currentInsc.length; i++) {
        const current = currentInsc[i];
        const form = formInsc[i];
        if (
          current.ineObjInscricao?.incNrId !== form.incNrId ||
          current.incBlCabecaChave !== form.ineBlCabecaChave
        ) {
          modified = true;
          break;
        }
      }
    }

    const currentFedIds = (currentState.petListFederacoesEtapa ?? [])
      .map((f) => f.fedNrId ?? 0)
      .sort((a, b) => a - b);
    const formFedIds = (this.federacaoEtapaForm?.fedNrIds ?? [])
      .slice()
      .sort((a, b) => a - b);

    if (
      currentFedIds.length !== formFedIds.length ||
      currentFedIds.some((id, i) => id !== formFedIds[i])
    ) {
      modified = true;
    }

    this.entTxMetadado = modified
      ? MetadataPutEnum.ALTERADO
      : MetadataPutEnum.INALTERADO;
  }

  static buildPutForm(
    newState: ParameterizationPostForm,
    currentState?: ICompleteStepParameterizationDto,
  ): ParameterizationPostForm {
    const updatedForm = new ParameterizationPostForm();
    updatedForm.petTxNome = newState.petTxNome;
    updatedForm.petTxDescricao = newState.petTxDescricao;
    updatedForm.petTxBanner = newState.petTxBanner;
    updatedForm.petTxExtensaoBanner = newState.petTxExtensaoBanner;
    updatedForm.catNrId = newState.catNrId;
    updatedForm.cheNrIdPrincipal = newState.cheNrIdPrincipal;
    updatedForm.petNrMaxJogosDia = newState.petNrMaxJogosDia;
    updatedForm.petNrIntervaloJogos = newState.petNrIntervaloJogos;
    updatedForm.petNrDuracaoEmb = newState.petNrDuracaoEmb;
    updatedForm.petNrMaxEmbSimultaneos = newState.petNrMaxEmbSimultaneos;
    updatedForm.petBlTrocaOrdemConfronto = newState.petBlTrocaOrdemConfronto;
    updatedForm.petTxTipo = newState.petTxTipo;
    updatedForm.petNrQtdChe = newState.petNrQtdChe;
    updatedForm.petNrQtdInc = newState.petNrQtdInc;
    updatedForm.petBlEmbDireto = newState.petBlEmbDireto;
    updatedForm.petBlEdicaoBloqueada = newState.petBlEdicaoBloqueada;
    updatedForm.inscricaoEtapaForms = newState.inscricaoEtapaForms;
    updatedForm.mocNrId = newState.mocNrId;
    updatedForm.federacaoEtapaForm = newState.federacaoEtapaForm;

    updatedForm.petNrQuantidadeMinimaAtuacoesQuadrasPrioritarias =
      newState.petNrQuantidadeMinimaAtuacoesQuadrasPrioritarias;
    updatedForm.entNrId = currentState?.petNrId ?? newState.entNrId;

    let modified = false;
    if (newState.petTxNome !== currentState?.petTxNome) modified = true;
    if (newState.petTxDescricao !== currentState?.petTxDescricao)
      modified = true;
    if (newState.petTxBanner !== currentState?.petTxBanner) modified = true;
    if (newState.catNrId !== currentState?.petObjCategoria?.catNrId)
      modified = true;
    if (
      newState.cheNrIdPrincipal !== currentState?.petObjChavePrincipal?.cheNrId
    )
      modified = true;
    if (newState.petNrIntervaloJogos !== currentState?.petNrIntervaloJogos)
      modified = true;
    if (newState.petNrMaxJogosDia !== currentState?.petNrMaxJogosDia)
      modified = true;
    if (
      newState.petNrDuracaoEmb?.toString() !==
      currentState?.petNrDuracaoEmb?.toString()
    )
      modified = true;
    if (
      newState.petNrMaxEmbSimultaneos !== currentState?.petNrMaxEmbSimultaneos
    )
      modified = true;
    if (
      newState.petBlTrocaOrdemConfronto !==
      currentState?.petBlTrocaOrdemConfronto
    )
      modified = true;
    if (newState.petTxTipo !== currentState?.petTxTipo) modified = true;
    if (newState.petNrQtdChe !== currentState?.petNrQtdChe) modified = true;
    if (newState.petNrQtdInc !== currentState?.petNrQtdInc) modified = true;
    if (newState.petBlEmbDireto !== currentState?.petBlEmbDireto)
      modified = true;
    if (newState.petBlEdicaoBloqueada !== currentState?.petBlEdicaoBloqueada)
      modified = true;
    if (newState.mocNrId !== currentState?.mocNrId) modified = true;
    if (
      newState.petNrQuantidadeMinimaAtuacoesQuadrasPrioritarias !==
      currentState?.petNrQuantidadeMinimaAtuacoesQuadrasPrioritarias
    )
      modified = true;

    const currentInsc = currentState?.petListInscricoesEtapa ?? [];
    const newInsc = newState.inscricaoEtapaForms ?? [];

    if (currentInsc.length !== newInsc.length) {
      modified = true;
    } else {
      for (let i = 0; i < currentInsc.length; i++) {
        const current = currentInsc[i];
        const novo = newInsc[i];
        if (
          current.ineObjInscricao?.incNrId !== novo.incNrId ||
          current.incBlCabecaChave !== novo.ineBlCabecaChave
        ) {
          modified = true;
          break;
        }
      }
    }

    updatedForm.entTxMetadado = modified
      ? MetadataPutEnum.ALTERADO
      : MetadataPutEnum.INALTERADO;

    return updatedForm;
  }

  static markAsDeleted(
    arenaId: number,
    wasDeleted: boolean,
  ): ParameterizationPostForm {
    let deletedArena = new ParameterizationPostForm();
    deletedArena.entNrId = arenaId;
    deletedArena.entTxMetadado = wasDeleted
      ? MetadataPutEnum.DELETADO
      : MetadataPutEnum.INALTERADO;
    return deletedArena;
  }
}
